module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_quiz_flashcards-5ec03ca51f825a347cf6f731880fac12.svg";